var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconPptxComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-Pptx ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: useCurrentColor ? 'currentColor' : '#EA4D1B'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.992 26V20.288H19.072C22.528 20.288 24.448 17.936 24.448 15.152C24.448 12.344 22.552 9.992 19.072 9.992H11.584V26H14.992ZM18.592 17.288H14.992V12.992H18.592C19.936 12.992 20.968 13.808 20.968 15.152C20.968 16.472 19.936 17.288 18.592 17.288Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconPptx = /*#__PURE__*/React.forwardRef(IconPptxComponent);
export default IconPptx;